import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import videoImg from "@baseImg/videos/video-aboutus-02.webp";
import VideoModal from "@components/base/Modal/VideoModal/VideoModal";

const BG = {
	blockIntro: {
		top: {},
		bottom: {
			blockTitle: 'Какво ни отличава?',
			blockDesc: 'Инфраструктура, на която клиентите ти могат да се доверят.',
			titleSize: 'h4',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: '',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: 'q72ki42zuw',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-12-11T10:34:00+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockIntro: {
		top: {},
		bottom: {
			blockTitle: 'Какво ни отличава?',
			blockDesc: 'Инфраструктура, на която клиентите ти могат да се доверят.',
			titleSize: 'h4',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: '',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: '2x62suhy3y',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-12-11T10:34:00+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];